"use client";

import type { PublisherSearchResult } from "./types";
import { SearchSectionHeader } from "./SearchSectionHeader";
import { PublisherResultItem } from "./PublisherResultItem";
import { INITIAL_PUBLISHERS_COUNT } from "./constants";

interface PublishersResultsSectionProps {
  publishers: PublisherSearchResult[];
  isExpanded: boolean;
  onToggleExpand: () => void;
  onSelect: () => void;
}

export function PublishersResultsSection({
  publishers,
  isExpanded,
  onToggleExpand,
  onSelect,
}: PublishersResultsSectionProps) {
  if (publishers.length === 0) return null;

  const displayedPublishers = isExpanded
    ? publishers
    : publishers.slice(0, INITIAL_PUBLISHERS_COUNT);
  const showExpandButton = publishers.length > INITIAL_PUBLISHERS_COUNT;
  const expandCount = publishers.length - INITIAL_PUBLISHERS_COUNT;

  return (
    <div>
      <SearchSectionHeader
        title="Publishers"
        showExpandButton={showExpandButton}
        isExpanded={isExpanded}
        expandCount={expandCount}
        onToggleExpand={onToggleExpand}
        showTopBorder
      />
      <ul className="divide-y divide-[#2a475e]">
        {displayedPublishers.map((publisher, index) => (
          <PublisherResultItem
            key={`publisher-${publisher.clanid}`}
            publisher={publisher}
            index={index}
            onSelect={onSelect}
          />
        ))}
      </ul>
    </div>
  );
}
